import React from 'react'

interface Props {
    isActive?: boolean
    children: React.ReactNode
}

export const NavigationListItem = ({ children, isActive = false }: Props) => {
    const activeClasses = isActive ? 'bg-accent-opacity-200 text-accent-700' : 'hover:bg-accent-opacity-100'

    return (
        <li className={`relative flex w-full hover:text-accent-700 ${activeClasses}`}>
            {isActive && <div className="absolute left-0 top-0 bottom-0 bg-accent-700 w-0.5" aria-hidden="true" />}
            {children}
        </li>
    )
}
